import React, { useState } from "react";
import {
  MyMessage,
  InputField,
  AddPageShell,
  AddSection,
} from "../../components/Component";
import { codeOk } from "../../../lib/index";
import { useDoSeeDataContext } from "../../../context/DoSeeDataContext";
import { getOneCinema } from "../../../lib/sysNavigation/SysNavigation";
import { FOLDERS, image_kit_folder } from "../utils/Utils";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import { useGeoPositionContext } from "../utils/geoPosition";
import { _TYPES_ } from "../utils/types";
import Pricing from "../../components/Pricing";
import GenerateDescription from "../utils/GenerateDescription";
import {
  ContactSection,
  SocialSection,
  GeoSection,
  VisibilitySection,
  DescriptionSection,
} from "../utils/AddSections";
import { FiImage, FiClock, FiFilm, FiDollarSign } from "react-icons/fi";

const Edit = () => {
  const { updateOneContent } = useDoSeeDataContext();
  const cinema: any = getOneCinema();
  const {
    country_id,
    entry_label,
    country_name,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const cinema_id = cinema?.cinema_id;

  const [title, setTitle] = useState<any>(cinema?.title);
  const [thumbnail, setThumbnail] = useState<any>(cinema?.thumbnail);
  const [thumbnailId, setThumbnailId] = useState<any>(cinema?.image_cdn_id);
  const [venue, setVenue] = useState<any>(cinema?.venue);
  const [openDays, setOpenDays] = useState<any>(cinema?.open_days);
  const [openedAt, setOpenedAt] = useState<any>(cinema?.opened_at);
  const [closedAt, setClosedAt] = useState<any>(cinema?.closed_at);
  const [email, setEmail] = useState<any>(cinema?.email_address);
  const [payLink, setPayLink] = useState<any>(cinema?.pay_link);
  const [phoneNumber, setPhoneNumber] = useState<any>(cinema?.phone_number);
  const [whatsapp, setWhatsapp] = useState<any>(cinema?.whatsapp);
  const [facebook, setFacebook] = useState<any>(cinema?.facebook);
  const [twitter, setTwitter] = useState<any>(cinema?.twitter);
  const [instagram, setInstagram] = useState<any>(cinema?.instagram);
  const [youtube, setYoutube] = useState<any>(cinema?.youtube);
  const [hashtags, setHashtags] = useState<any>(cinema?.hashtag);
  const [googleMapCode, setGoogleMapCode] = useState<any>(cinema?.google_map_code);
  const [latitude, setLatitude] = useState<any>(cinema?.latitude);
  const [longitude, setLongitude] = useState<any>(cinema?.longitude);
  const [formattedAddress, setFormattedAddress] = useState<any>(
    cinema?.formatted_address
  );
  const [featured, setFeatured] = useState<any>(cinema?.featured);
  const [promoted, setPromoted] = useState<any>(
    cinema?.promoted ? cinema?.promoted : "no"
  );
  const [cinemaStatus, setCinemaStatus] = useState<any>(cinema?.status);
  const [description, setDescription] = useState<any>(cinema?.description);
  const [expo, setExpo] = useState<any>(cinema?.expo);
  const [pricing, setPricing] = useState<any>(cinema?.Pricings);
  const [showDescriptionModal, setShowDescriptionModal] = useState<any>(null);

  const cinemaRoutes = "/data/cinema";

  const responses = (isError: any, message: any) => {
    setError(isError);
    setLoading(false);
    setSuccess(!isError);
    setErrorMessage(message);
  };

  const updateOneCinemaHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId) {
      responses(true, "Image Required");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const data = {
      country_id: country_id ? country_id : cinema?.country_id,
      first_level_id: first_level_id ? first_level_id : 0,
      second_level_id: second_level_id ? second_level_id : 0,
      third_level_id: third_level_id ? third_level_id : 0,
      fourth_level_id: fourth_level_id ? fourth_level_id : 0,
      title: title,
      slug: title?.toLowerCase().replace(/\s/g, "_"),
      description: description,
      city_level: "level",
      venue: venue,
      open_days: openDays,
      opened_at: openedAt,
      closed_at: closedAt,
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      phone_number: phoneNumber,
      email_address: email,
      whatsapp: whatsapp,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      youtube: youtube,
      hashtag: hashtags,
      audio_ad: "none",
      google_map_code: googleMapCode,
      latitude: latitude,
      longitude: longitude,
      formatted_address: formattedAddress,
      country_short: "none",
      status: cinemaStatus,
      featured: featured,
      promoted: promoted,
      expo: expo,
      pricing: pricing,
      pay_link: payLink,
    };

    const { message, status } = await updateOneContent({
      data_id: cinema_id,
      data: data,
      content: _TYPES_.CINEMA,
      position: {
        country_id,
        first_level_id,
        second_level_id,
        third_level_id,
        fourth_level_id,
      },
    });

    if (status === codeOk) responses(false, message);
    else responses(true, message);
  };

  const clearMessages = () => {
    setError(null as any);
    setSuccess(null as any);
  };

  return (
    <AddPageShell
      backRoute={cinemaRoutes}
      eyebrow="DoSee Data • Cinemas"
      title="Edit Cinema"
      subtitle={`Update a cinema in ${entry_label || "this destination"}.`}
      icon={<FiFilm className="h-5 w-5" />}
      modals={
        showDescriptionModal ? (
          <GenerateDescription
            setDescription={setDescription}
            setShowDescriptionModal={setShowDescriptionModal}
          />
        ) : null
      }
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneCinemaHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        title="Cover Image"
        hint="A poster, marquee or theatre photo."
        icon={<FiImage className="h-4 w-4" />}
      >
        <ImageKitUpload
          thumbnail={thumbnail}
          thumbnailId={thumbnailId}
          setThumbnail={setThumbnail}
          setThumbnailId={setThumbnailId}
          folder={image_kit_folder(country_name, FOLDERS.CINEMA)}
        />
      </AddSection>

      <AddSection title="Cinema Details" hint="Title, venue and address.">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
          <InputField
            props={{
              id: "title",
              title: "Title",
              type: "text",
              value: title || "",
              onChange: (e: any) => {
                setTitle(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "venue",
              title: "Venue",
              type: "text",
              value: venue || "",
              onChange: (e: any) => {
                setVenue(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "formatted_address",
              title: "Formatted Address",
              type: "address",
              value: formattedAddress || "",
              onChange: (e: any) => {
                setFormattedAddress(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Date & Time"
        hint="Operating days and hours."
        icon={<FiClock className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          <InputField
            props={{
              id: "open_days",
              title: "Open Days",
              type: "text",
              value: openDays || "",
              onChange: (e: any) => {
                setOpenDays(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "opened_at",
              title: "Opened At",
              type: "time",
              value: openedAt || "",
              onChange: (e: any) => {
                setOpenedAt(e.target.value);
                clearMessages();
              },
            }}
          />
          <InputField
            props={{
              id: "closed_at",
              title: "Closed At",
              type: "time",
              value: closedAt || "",
              onChange: (e: any) => {
                setClosedAt(e.target.value);
                clearMessages();
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        title="Pricing"
        hint="Optional pricing tiers."
        icon={<FiDollarSign className="h-4 w-4" />}
      >
        <Pricing pricing={pricing} setPricing={setPricing} />
      </AddSection>

      <ContactSection
        phone={phoneNumber}
        setPhone={setPhoneNumber}
        email={email}
        setEmail={setEmail}
        payLink={payLink}
        setPayLink={setPayLink}
        clearMessages={clearMessages}
      />

      <SocialSection
        whatsapp={whatsapp}
        setWhatsapp={setWhatsapp}
        facebook={facebook}
        setFacebook={setFacebook}
        twitter={twitter}
        setTwitter={setTwitter}
        instagram={instagram}
        setInstagram={setInstagram}
        youtube={youtube}
        setYoutube={setYoutube}
        clearMessages={clearMessages}
      />

      <GeoSection
        googleMapCode={googleMapCode}
        setGoogleMapCode={setGoogleMapCode}
        latitude={latitude}
        setLatitude={setLatitude}
        longitude={longitude}
        setLongitude={setLongitude}
        clearMessages={clearMessages}
      />

      <VisibilitySection
        statusId="cinema_status"
        setStatus={setCinemaStatus}
        setFeatured={setFeatured}
        setPromoted={setPromoted}
        setExpo={setExpo}
        status={cinemaStatus}
        featured={featured}
        promoted={promoted}
        expo={expo}
        clearMessages={clearMessages}
      />

      <DescriptionSection
        description={description}
        setDescription={setDescription}
        hashtags={hashtags}
        setHashtags={setHashtags}
        onGenerate={() => setShowDescriptionModal(true)}
        clearMessages={clearMessages}
      />
    </AddPageShell>
  );
};

export default Edit;
